/*eslint-disable */
import React, { useState } from 'react'

import styles from './styles'
import Info from 'public/assets/svg/info.svg'
import Instagram from 'public/assets/svg/instagram.svg'
import { MEDIA_TYPES } from 'aria-viewer/tour/constants'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import { motion } from 'framer-motion'
import ShareMenuContainer from '../../containers/ShareMenu'
import { sanitize } from 'dompurify'

const InstagramViewer = props => {
    const [description, setDescription] = useState(false)
    const { media, inst_id, loc_id, classes, onLoad, showDescription, showTitle } = props
    const { photoid, id, description: descriptionInfo } = media
    const MEDIA_URLS = {
        [MEDIA_TYPES.photo]: `${process.env.REACT_APP_BASE_URL}/tour/photos/${inst_id}/${loc_id}?id=${photoid}`,
        [MEDIA_TYPES.video]: `${process.env.REACT_APP_BASE_URL}/tour/videos/${inst_id}/${loc_id}?id=${id}`,
    }
    onLoad && onLoad(true)
    const embedId = media.mediaType === MEDIA_TYPES.photo ? media.url : media.videoid

    const animations = {
        open: {
            x: '0%',
            transition: {
                ease: [0.28, 0.57, 0.2, 1],
                duration: 0.5,
            },
        },
        closed: {
            x: '100%',
            transition: {
                ease: 'easeIn',
                duration: 0.25,
            },
        },
    }

    return (
        <div className={classes.viewer}>
            {showTitle && (
                <div className={classes.imgText} data-testid="title">
                    {media.title}
                </div>
            )}
            <iframe
                className={classes.instagramMedia}
                src={`https://www.instagram.com/p/${embedId}/embed/?cr=1&wp=1080&rd=${encodeURIComponent(
                    window.location.origin
                )}&rp=${encodeURIComponent(window.location.pathname.substring(0, 200))}`}
                allowtransparency="true"
                frameborder="0"
                scrolling="auto"
            ></iframe>
            {showDescription && (
                <span>
                    <motion.div
                        initial={{ x: '100%' }}
                        variants={animations}
                        animate={'open'}
                        className={classes.infoPanel}
                    >
                        <span className={classes.instagram}>
                            <img src={Instagram} />
                            <span className={classes.instagramTitle}>{media.username}</span>
                            <div
                                className={classes.instagramDescription}
                                dangerouslySetInnerHTML={{
                                    __html: sanitize(descriptionInfo, { ADD_ATTR: ['target'] }),
                                }}
                            ></div>
                        </span>
                    </motion.div>
                    {descriptionInfo && (
                        <div className={classes.info} onClick={() => setDescription(!description)} data-testid="info">
                            <img src={Info} />
                        </div>
                    )}
                    <div className={classes.shareMenu}>
                        <span
                            style={{
                                cursor: 'pointer',
                                position: 'absolute',
                                bottom: '0%',
                                right: '0%',
                            }}
                        >
                            <ShareMenuContainer
                                url={MEDIA_URLS[media.mediaType]}
                                className={classes.shareMenu}
                                svgColor="#FFFFFF"
                            />
                        </span>
                    </div>
                </span>
            )}
        </div>
    )
}

InstagramViewer.defaultProps = {
    showTitle: false,
    showDescription: false,
}

export default compose(injectSheet(styles))(InstagramViewer)
